<script>
  // AuthModal — covers the page until /api/auth/check confirms a valid
  // session cookie. Mirrors the legacy vanilla flow but as a reactive
  // component. Exposes `authed` via callback so App.svelte can render
  // the rest of the UI only after a successful login.
  import { onMount } from "svelte";
  import { api } from "../api/client.js";

  let { onAuthed } = $props();

  let checking = $state(true);
  let password = $state("");
  let submitting = $state(false);
  let errorMsg = $state(null);

  onMount(async () => {
    try {
      const body = await api.get("/api/auth/check");
      if (body?.authenticated) {
        onAuthed?.();
        return;
      }
    } catch { /* fall through to login UI */ }
    checking = false;
    // Focus the password input on the next tick so the user can type
    // straight away without clicking.
    requestAnimationFrame(() => document.getElementById("auth-pw")?.focus());
  });

  async function submit(e) {
    e.preventDefault();
    if (submitting) return;
    submitting = true;
    errorMsg = null;
    try {
      await api.post("/api/auth/login", { password });
      onAuthed?.();
    } catch (err) {
      errorMsg = err.message;
      password = "";
      requestAnimationFrame(() => document.getElementById("auth-pw")?.focus());
    } finally {
      submitting = false;
    }
  }
</script>

{#if checking}
  <div class="auth-overlay" role="status">
    <div class="auth-panel">
      <p class="muted">Đang kiểm tra session...</p>
    </div>
  </div>
{:else}
  <div class="auth-overlay">
    <form class="auth-panel" onsubmit={submit}>
      <h2>🔒 Đăng nhập</h2>
      <p class="muted">Theme Tool Automation cần password để truy cập.</p>
      <input id="auth-pw" type="password" placeholder="Password"
             autocomplete="current-password"
             bind:value={password} disabled={submitting} required />
      <button type="submit" class="primary-btn" disabled={submitting || !password}>
        {submitting ? "Đang vào..." : "Đăng nhập"}
      </button>
      {#if errorMsg}
        <div class="error">{errorMsg}</div>
      {/if}
    </form>
  </div>
{/if}

<style>
  .auth-overlay {
    position: fixed;
    inset: 0;
    background: var(--bg);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
  }

  .auth-panel {
    background: var(--panel);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 28px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: min(380px, 92vw);
    box-shadow: var(--shadow-md);
  }

  h2 {
    margin: 0;
    font-size: 1.1rem;
    color: var(--text-strong);
  }

  .muted {
    margin: 0;
    color: var(--muted);
    font-size: 0.85rem;
  }

  input {
    padding: 10px 12px;
    font-size: 0.95rem;
  }

  .error {
    color: #ff8585;
    background: rgba(248, 113, 113, 0.08);
    border: 1px solid rgba(248, 113, 113, 0.3);
    border-radius: 6px;
    padding: 8px 10px;
    font-size: 0.82rem;
  }
</style>
